import {
  faBooks,
  faCancel,
  faClone,
  faDownload,
  faEye,
  faKey,
  faMagnifyingGlass,
  faPenToSquare,
  faRefresh,
  faRotateLeft,
  faSave,
  faSearch,
  faTrash,
} from '@fortawesome/sharp-solid-svg-icons';

function TableRowDownloadButton(onClick, hide?: string) {
  return {
    Title: 'Download',
    Icon: faDownload,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowRefreshButton(onClick, hide?: string) {
  return {
    Title: 'Refresh',
    Icon: faRefresh,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowViewButton(onClick, hide?: string) {
  return {
    Title: 'View',
    Icon: faSearch,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowSaveButton(onClick, hide?: string) {
  return {
    Title: 'Save',
    Icon: faSave,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowClearMFASecretButton(onClick, hide?: string) {
  return {
    Title: 'Clear MFA Secret',
    Icon: faRotateLeft,
    Cancel: true,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowResetPasswordButton(onClick, hide?: string) {
  return {
    Title: 'Reset Password',
    Icon: faKey,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowPreviewButton(onClick, hide?: string) {
  return {
    Title: 'Preview',
    Icon: faMagnifyingGlass,
    Cancel: true,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowViewDetailsButton(onClick) {
  return {
    Title: 'View Details',
    Icon: faBooks,
    Cancel: true,
    OnClick: onClick,
  };
}

function TableRowViewDetailButton(onClick: (id: string) => void, hide?: string) {
  return {
    Title: 'View Detail',
    Icon: faEye,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowCancelRunButton(onClick: (id: string) => void, hide?: string) {
  return {
    Title: 'Cancel',
    Icon: faCancel,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowEditButton(onClick: (id: string) => void, hide?: string) {
  return {
    Title: 'Edit',
    Icon: faPenToSquare,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowDuplicateButton(onClick: (id: string) => void, hide?: string) {
  return {
    Title: 'Duplicate',
    Icon: faClone,
    OnClick: onClick,
    Hidden: hide,
  };
}

function TableRowDeleteButton(onClick: (id: string) => void, hide?: string) {
  return {
    Title: 'Delete',
    Icon: faTrash,
    Cancel: true,
    OnClick: onClick,
    Hidden: hide,
  };
}

export {
  TableRowCancelRunButton,
  TableRowClearMFASecretButton,
  TableRowDeleteButton,
  TableRowDownloadButton,
  TableRowDuplicateButton,
  TableRowEditButton,
  TableRowPreviewButton,
  TableRowRefreshButton,
  TableRowResetPasswordButton,
  TableRowSaveButton,
  TableRowViewButton,
  TableRowViewDetailButton,
  TableRowViewDetailsButton,
};
